import styled from 'styled-components'

import { media } from 'styles/media'

export const SectionTitle = styled.h3`
  color: ${({ theme }) => theme?.['-ds-core-400']?.value};
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xs']?.['font-size']?.value};
  font-weight: 400;
  letter-spacing: 0.08em;
  line-height: 1.3;
  text-transform: uppercase;
  margin-bottom: 8px;
`

export const SectionSubtitle = styled.h4`
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xl']?.['font-size']?.value};
  font-weight: 400;
  line-height: 1.3;
  margin-bottom: 24px;

  ${media.md`
    margin-bottom: 32px;
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-xxl']?.['font-size']?.value};
  `}
`

export const SectionParagraph = styled.p`
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xs']?.['font-size']?.value};
  font-weight: 300;
  line-height: 1.4;

  ${media.md`
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-md']?.['font-size']?.value};
    max-width: 640px;
    margin: 0 auto;
  `}
`

export const SectionOuter = styled.section`
  margin: 72px auto;

  ${media.md`
    text-align: center;
    margin: 72px auto 100px auto;
  `}
`

export const Padded = styled.div`
  padding: 0 16px;

  ${media.md`
    padding: 0 32px;
  `}
`
